import React from 'react';
import { EditFilled } from '@ant-design/icons';
import { Button } from 'antd';
import * as Flag from 'country-flag-icons/react/3x2';
import countries from 'i18n-iso-countries';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../../store/auth';
import { formatDate } from '../../../utils';
import JoinOurCommunity from '../TippingArticles/JoinOurCommunity';
import MyBusinesses from './MyBusinesses';

import styles from './index.module.scss';
import DisplayHtmlContent from '../../Common/DisplayHtmlContent';

export default function ProfileContent(): React.ReactElement {
  const { user } = useAuth();
  const navigate = useNavigate();
  const iso3 = user?.country?.iso3;
  const alpha2 = iso3 ? countries.alpha3ToAlpha2(iso3) : null;
  const FlagComponent = alpha2 ? Flag[alpha2 as keyof typeof Flag] : null;

  return (
    <>
      <div className={styles.wrapper}>
        <div className={styles.container}>
          <div className={styles.header}>
            <h2>My profile</h2>
            <Button
              className={styles.editBtn}
              type="primary"
              size="large"
              icon={<EditFilled />}
              onClick={() => navigate('/profile-edit')}
            >
              Edit Profile
            </Button>
          </div>
          <div className={styles.userInfo}>
            <div
              className={styles.content}
              style={{ justifyContent: 'center' }}
            >
              <div className={styles.userPersonalInfo}>
                {/* <img src="/media/userIcon.png" alt="" /> */}
                <img
                  src={
                    user?.photo ? user.photo.location : '/media/userIcon.png'
                  }
                  alt=""
                  className={styles.userPhoto}
                />
                <div>
                  <h3 className={styles.userName}>
                    {user?.name}
                    {FlagComponent ? (
                      <FlagComponent style={{ width: 15 }} />
                    ) : null}
                  </h3>
                  <span>{user?.email}</span>
                </div>
              </div>
            </div>
            <div className={styles.content}>
              <h3>Personal details</h3>
              <div className={styles.details}>
                <div className={styles.item}>
                  <div>
                    <span>Industry</span>
                    <h4>
                      {user?.subCategory?.header || (
                        <span className={styles.placeholder}>—</span>
                      )}
                    </h4>
                  </div>
                  <div>
                    <span>Country</span>
                    <h4>
                      {user?.country?.name || (
                        <span className={styles.placeholder}>—</span>
                      )}
                    </h4>
                  </div>
                </div>
                <div className={styles.item}>
                  <div>
                    <span>Member since</span>
                    <h4>
                      {user?.createdAt ? (
                        formatDate(user.createdAt)
                      ) : (
                        <span className={styles.placeholder}>—</span>
                      )}
                    </h4>
                  </div>
                  <div>
                    <span>Zip Code</span>
                    <h4>
                      {user?.zipCode || (
                        <span className={styles.placeholder}>—</span>
                      )}
                    </h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {user && user.description && (
            <div className={styles.content} style={{ width: '100%' }}>
              <h3>About Me</h3>
              <DisplayHtmlContent html={user.description} />
            </div>
          )}
          {user?.businesses?.length ? (
            <div className={styles.content} style={{ width: '100%' }}>
              <MyBusinesses businesses={user.businesses} />
            </div>
          ) : null}
        </div>
      </div>

      <JoinOurCommunity />
    </>
  );
}
